import { MetaDataRuleDefinitionDTO } from "../DTO/metaDataRuleDefinitionDTO";

export class MetaDataRuleDefinition{
    public id!: number;
    public name!: string;
    public function!: string;
    public recordsIncluded!: string;
    public fieldSelection!: string;
    public fieldDataType!: string;

    public static mapFromDTO(param:MetaDataRuleDefinitionDTO):MetaDataRuleDefinition{ 
        if (!param) throw new Error("parameter is null")
        let obj = new MetaDataRuleDefinition();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.function = param.function;
            obj.recordsIncluded = param.recordsIncluded;
            obj.fieldSelection = param.fieldSelection;
            obj.fieldDataType = param.fieldDataType;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:MetaDataRuleDefinition):MetaDataRuleDefinitionDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new MetaDataRuleDefinitionDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.function = param.function;
            dto.recordsIncluded = param.recordsIncluded;
            dto.fieldSelection = param.fieldSelection;
            dto.fieldDataType = param.fieldDataType;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    get description(){
        let desc=this.function;
        switch(this.recordsIncluded){
            case 'f':
                desc=desc+'-First Record';
                break;
            case 'l':
                desc=desc+'-Last Record';
                break;
            case 'a':
                desc=desc+'-All Records';
                break;
            default:
                break;
        }
        return desc;
    }
}